import { render, staticRenderFns } from "./MyEventHorReadOnly.vue?vue&type=template&id=32d64f6a&scoped=true&"
import script from "./MyEventHorReadOnly.vue?vue&type=script&lang=js&"
export * from "./MyEventHorReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./MyEventHorReadOnly.vue?vue&type=style&index=0&id=32d64f6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d64f6a",
  null
  
)

export default component.exports